import React, { useState, useEffect } from 'react'
import { Alert, Box, TextField, Button, TableContainer, Table, TableHead, TableCell, TableRow, Paper, TableBody, Select, MenuItem, FormControl, CircularProgress } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { downloadDocument, getEquipmentTransport, postEquipmentTransport } from '../../../../../actions/tigercat-burns/tigercat-actions';
import { v4 as uuidv4 } from 'uuid';

const EquipmentTransport = ({ projectId, project }) => {
    const [equipmentTransportState, setEquipmentTransportState] = useState([])
    const dispatch = useDispatch()
    const equipmentTransport = useSelector(state => state.tigercatBurnsReducer.equipmentTransports.data)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(false)

    useEffect(() => {
        dispatch(getEquipmentTransport(projectId));
    }, [dispatch, projectId]);

    useEffect(() => {
        const formDataArray = equipmentTransport?.map((item) => {
            const formData = new FormData();
            formData.append('id', item.id);
            formData.append('date', item.date);
            formData.append('equipmentTransported', item.equipmentTransported);
            formData.append('equipmentMass', item.equipmentMass);
            formData.append('distanceTransported', item.distanceTransported);
            formData.append('transportType', item.transportType);
            formData.append('fuelType', item.fuelType);
            formData.append('disabled', true)
            return formData;
        });
        setEquipmentTransportState(formDataArray);
    }, [equipmentTransport]);

    const handleAddItem = () => {
        setEquipmentTransportState((prevState) => {
            const state = [...prevState]
            const formData = new FormData();
            formData.append('id', null);
            formData.append('date', null);
            formData.append('equipmentTransported', null);
            formData.append('equipmentMass', null);
            formData.append('distanceTransported', null);
            formData.append('transportType', null);
            formData.append('fuelType', null);
            formData.append('rowId', uuidv4())
            state.push(formData)
            return state
        })
    }

    const handleDateSelection = (date, dataId) => {
        setEquipmentTransportState((prevState) => {
            return prevState.map((item) => {
                if (item.get('rowId') === dataId) {
                    const formattedDate = moment(date).format('YYYY-MM-DD');
                    item.set('date', formattedDate);
                }
                return item;
            });
        });
    }

    const handleInputChange = (e, name, dataId) => {
        setEquipmentTransportState((prevState) => {
            return prevState.map((item) => {
                if (item.get('rowId') === dataId) {
                    item.set(name, e.target.value);
                }
                return item;
            });
        });
    }

    const fuelTypes = [
        { id: 0, name: 'Diesel Red' },
        { id: 1, name: 'Diesel Clear' },
        { id: 2, name: 'Gasoline' }
    ]

    const transportType = [
        { id: 0, name: 'Medium-and-Heavy-Duty-Truck' },
    ]

    const handleSubmitData = () => {
        setLoading(true)
        let hasError = false
        equipmentTransportState.forEach((i) => {
            if (i.get('date') === 'null' ||
                i.get('equipmentTransported') === 'null' ||
                i.get('equipmentMass') === 'null' ||
                i.get('distanceTransported') === 'null' ||
                i.get('fuelType') === 'null' ||
                i.get('transportType') === 'null') {
                setError(true)
                hasError = true
                return
            }
        })
        if (!hasError) {
            setError(false)
            dispatch(postEquipmentTransport(projectId, equipmentTransportState)).then(() => {
                dispatch(getEquipmentTransport(projectId))
                setLoading(false)
            })
        } else {
            setLoading(false)
        }
    }

    const handleDownload = async () => {
        try {
            dispatch(downloadDocument(projectId, 'equipment_transport')).then((response) => {

                // Create a downloadable link for the Excel file
                const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${project}_equipment_transport.xlsx`); // Set the file name
                document.body.appendChild(link);
                link.click();
                link.remove();
            })

        } catch (err) {
            console.error('Error downloading Equipment Transport:', err);
        }
    };

    return (
        <>
            <h2>Equipment Transport</h2>
            <Button variant='contained' sx={{ height: 'auto', float: 'right', mt: 2, mb: 2 }} onClick={handleDownload}>Download Excel</Button>
            <TableContainer key={0} component={Paper} >
                <Table aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="left">
                                Date
                            </TableCell>
                            <TableCell align="left">
                                List Equipment Transported
                            </TableCell>
                            <TableCell align="left">
                                Mass of Equipment (metric tonne)
                            </TableCell>
                            <TableCell align="left">
                                Distance Transported (km)
                            </TableCell>
                            <TableCell align="left">
                                Fuel Type
                            </TableCell>
                            <TableCell align="left">
                                Transport Type
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {equipmentTransportState?.map((data, index) => {
                            return (
                                <TableRow key={index}>
                                    <TableCell align="left">
                                        <FormControl>
                                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                                <DatePicker
                                                    slotProps={{
                                                        textField: {
                                                            error: false,
                                                        },
                                                    }}
                                                    name={'date'}
                                                    value={data.get('date') ? moment(data.get('date'), 'YYYYMMDD') : null}
                                                    onChange={(e) => handleDateSelection(e._d, data.get('rowId'))}
                                                    disabled={data.get('disabled') ?? false}
                                                    format="MM/DD/YYYY"
                                                />
                                            </LocalizationProvider>
                                        </FormControl>
                                    </TableCell>
                                    <TableCell align="left">
                                        <TextField
                                            name='equipmentTransported'
                                            value={data.get('equipmentTransported') === 'null' ? '' : data.get('equipmentTransported')}
                                            onChange={(e) => handleInputChange(e, e.target.name, data.get('rowId'))}
                                            type="text"
                                            disabled={data.get('disabled') ?? false}

                                        />
                                    </TableCell>
                                    <TableCell align="left">
                                        <TextField
                                            name='equipmentMass'
                                            value={data.get('equipmentMass') === 'null' ? '' : data.get('equipmentMass')}
                                            onChange={(e) => handleInputChange(e, e.target.name, data.get('rowId'))}
                                            type="text"
                                            disabled={data.get('disabled') ?? false}

                                        />
                                    </TableCell>
                                    <TableCell align="left">
                                        <TextField
                                            name='distanceTransported'
                                            value={data.get('distanceTransported') === 'null' ? '' : data.get('distanceTransported')}
                                            onChange={(e) => handleInputChange(e, e.target.name, data.get('rowId'))}
                                            type="text"
                                            disabled={data.get('disabled') ?? false}

                                        />
                                    </TableCell>
                                    <TableCell align="left">
                                        <Select name='fuelType' value={data.get('fuelType')} disabled={data.get('disabled') ?? false} fullWidth onChange={(e) => handleInputChange(e, e.target.name, data.get('rowId'))}>
                                            {fuelTypes?.map(type => {
                                                return (
                                                    <MenuItem key={type.id} value={type.name} >
                                                        {type.name}
                                                    </MenuItem>
                                                );
                                            })}
                                        </Select>
                                    </TableCell>
                                    <TableCell align="left">
                                        <Select name='transportType' value={data.get('transportType')} disabled={data.get('disabled') ?? false} fullWidth onChange={(e) => handleInputChange(e, e.target.name, data.get('rowId'))}>
                                            {transportType?.map(type => {
                                                return (
                                                    <MenuItem key={type.id} value={type.name} >
                                                        {type.name}
                                                    </MenuItem>
                                                );
                                            })}
                                        </Select>
                                    </TableCell>
                                </TableRow>
                            )
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
            {error ? <Alert severity='error' sx={{ my: 2 }}>Please fill out all fields before submitting</Alert> : null}
            <Box sx={{ position: 'relative', mb: 10 }}>
                <Button variant='contained' sx={{ height: 'auto', mt: 2 }} onClick={handleAddItem}>Add Entry</Button>
                {loading ? <CircularProgress sx={{ position: 'absolute', left: '125px', top: '12px' }}></CircularProgress> : <Button variant='contained' sx={{ height: 'auto', mt: 2, ml: 3 }} onClick={handleSubmitData}>Submit Data</Button>}
                {loading && <Alert severity='info' sx={{ my: 2 }}>Please be patient during data submission as file uploads can take some time to complete</Alert>}
            </Box>
        </>
    )
}

export default EquipmentTransport